import TopPerformingSalons from "./TopPerformingSalons";
import ActiveSalons from "./ActiveSalons";
import { SearchOutlined } from "@ant-design/icons";
import { Input, Spin } from "antd";
import { useState } from "react";
import { location } from "../../../types/calendar";
import { useQuery } from "@tanstack/react-query";
import { adminGetOverViewDetails } from "../../../network/admin";

type Props = {};

const SalonsStats = ({}: Props) => {
  const [search, setSearch] = useState("");

  const { data, isLoading } = useQuery(
    ["admin-overview", search],
    () =>
      adminGetOverViewDetails({
        search,
      }),
    {
      select: (res) => res.data,
    }
  );
  return (
    <div className="flex items-center flex-col gap-4 h-full">
      <Input
        size="small"
        placeholder={"Search salons"}
        className="w-full rounded-3xl h-fit py-2 px-4 bg-[#F4F7FE]"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        prefix={<SearchOutlined className="text-color-primary mr-2" />}
        style={{ paddingRight: 30 }} // Increase paddingRight to accommodate the icon
      />
      {isLoading ? (
        <Spin size="large" />
      ) : (
        <TopPerformingSalons locations={data?.top_salons} />
      )}
      <ActiveSalons
        activeSalons={data?.active_salons_count || 0}
        percentage={+Number(data?.active_salons_percentage)?.toFixed(1) || 0}
      />
    </div>
  );
};

export default SalonsStats;
